// extracted by mini-css-extract-plugin
export default {"container":"AdminDashboard_container__Pk7n1","selected":"AdminDashboard_selected__sIaEh","logo":"AdminDashboard_logo__eKwdu","open":"AdminDashboard_open__d8D9K"};